export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/sensitive-07b49435e167772673cc7e3df7c2df36.svg";